import Errors from '@/utils/Errors'

export default
{
    methods:
    {
        sendForm(action, model, callback)
        {
            this.loading = true
            this.$store.dispatch(action, model).then(res => {
                this.loading = false
                if (callback)
                    callback()
            }).catch(e => {
                if (e && e.errors)
                    this.errors = e.errors
                this.loading = false
            })
        },
    },

    data()
    {
        return {
            loading: false,
            errors: new Errors()
        }
    },

}


// WEBPACK FOOTER //
// ./src/mixins/ActionForm.js